import { render, staticRenderFns } from "./registerParcelStep2.vue?vue&type=template&id=12d8323c&scoped=true&"
import script from "./registerParcelStep2.vue?vue&type=script&lang=js&"
export * from "./registerParcelStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8323c",
  null
  
)

export default component.exports